const AdminDashboardPage = () => {
  return (
    <div>
      <h1 className="text-3xl font-outfit font-bold text-slate-900 mb-6">
        Dashboard
      </h1>
      <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
        <div className="bg-white p-6 rounded-lg shadow-sm border border-slate-200">
          <h3 className="text-slate-500 text-sm font-medium">Total Products</h3>
          <p className="text-3xl font-bold text-slate-900 mt-2">--</p>
        </div>
        <div className="bg-white p-6 rounded-lg shadow-sm border border-slate-200">
          <h3 className="text-slate-500 text-sm font-medium">Total Orders</h3>
          <p className="text-3xl font-bold text-slate-900 mt-2">--</p>
        </div>
        <div className="bg-white p-6 rounded-lg shadow-sm border border-slate-200">
          <h3 className="text-slate-500 text-sm font-medium">Revenue</h3>
          <p className="text-3xl font-bold text-slate-900 mt-2">₹--</p>
        </div>
      </div>
    </div>
  );
};

export default AdminDashboardPage;